export default "__VITE_ASSET__C$PONlDP__"